<template>
  <div class="main-content">
    <!-- Section: inner-header -->
    
 <div class="container pt-100">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
    <h2 class="text-theme-colored text-center">Privacy policy</h2>
            </div>
          </div>
        </div>
      </div>

    <!-- Section: Terms -->
    <section id="terms">
      <div class="container pt-70">
        <div class="section-content">
          <h3 class="text-theme-colored">
            INFORMATIVA E RICHIESTA DI CONSENSO PER IL TRATTAMENTO DEI DATI
            PERSONALI
          </h3>

          Gentile Utente/Interessato,
          <br />
          la presente Informativa è resa ai sensi del D. Lgs. 30 giungo 2003 n.
          196 e successive modifiche (cd. Codice Privacy), nonché ai sensi degli
          artt. 13 e 14 del Regolamento (UE) 2016/679 del Parlamento Europeo e
          del Consiglio del 27 aprile 2016. La informiamo che i dati personali
          da Lei forniti nell’ambito della consultazione del sito
          <a href="https://www.sarahfitnessmovementflow.com" target="_blank">https://www.sarahfitnessmovementflow.com</a>, volta all'acquisto di corsi
          sportivi e percorsi alimentari da Abdessalem Sarah, saranno trattati
          dalla citata professionista in qualità di Titolare del trattamento (di
          seguito anche Titolare) nel rispetto dei principi di protezione
          stabiliti dal Codice in materia di dati personali e successive
          modifiche, nonché di tutti gli interventi legislativi europei e
          nazionali e / o provvedimenti delle Autorità di controllo.
          L’informativa che segue è resa per il sito
          <a href="https://www.sarahfitnessmovementflow.com" target="_blank">https://www.sarahfitnessmovementflow.com</a> e non anche per altri siti
          web eventualmente consultati dall’Utente tramite link che vi rimanda.
          <h5 class="text-theme-dark">A. FINALITÀ DEL TRATTAMENTO</h5>
          Il trattamento dei dati spontaneamente forniti dall’Utente al fine di
          acquistare programmi di allenamento personalizzato anche combinati con
          percorsi alimentari è effettuato dal Titolare per consentirgli di: •
          consentire all’utente l’acquisto dei programmi di allenamento
          personalizzato anche combinati con percorsi alimentari di proprietà
          del Titolare del Trattamento; • Inviare all’utente le informazioni
          relative ai pacchetti acquistati tramite il presente sito web; •
          adempiere ad obblighi di legge in materia contabile e fiscale; • per
          facilitare la fornitura di eventuali futuri servizi o per facilitare
          eventuali futuri acquisti che l’utente voglia effettuare presso il
          presente sito o strutture di proprietà di Abdessalem Sarah, anche
          tramite l’inserimento nei sistemi informatici del predetto soggetto.
          Tale trattamento è facoltativo e sarò effettuato solo previo consenso
          dell’Utente. • per fini di marketing e dunque al fine di effettuare la
          profilazione dell’Utente e conseguentemente inviargli adeguate offerte
          commerciali. Tale trattamento è facoltativo e sarò effettuato solo
          previo consenso dell’Utente.
          <h5 class="text-theme-dark">
            B. TIPOLOGIA DI DATI RACCOLTI E TRATTATI
          </h5>
          I dati personali raccolti sono: • Nome, cognome; • E-mail; • indirizzo
          di residenza, di domicilio o di dimora; • indirizzo di fatturazione; •
          telefono fisso e/o mobile. Tali dati sono definiti quali dati comuni.
          Il titolare del trattamento verrà altresì necessariamente a conoscenza
          dei dati bancari dell’Utente, tali dati sono da considerarsi quali
          dati sensibili. I dati segnalati con il campo “obbligatorio” sono
          obbligatori per poter acquistare i servizi di Abdessalem Sarah. Il
          titolare verrà necessariamente a contatto con i dati bancari in quanto
          l’acquisto dei prodotti potrà essere concluso solamente effettuando il
          pagamento richiesto. Ferma restando l’autonomia personale
          dell’Interessato e fermo restando il conferimento di dati di
          navigazione, l’indicazione dei dati segnalati con il campo
          “obbligatorio” nel form è indispensabile ed il mancato conferimento,
          anche parziale, dei dati espressamente indicati come necessari
          determinerà l’impossibilità per il Titolare di procedere alla vendita
          dei propri prodotti.
          <h5 class="text-theme-dark">
            C. TITOLARE, RESPONSABILI E INCARICATI
          </h5>
          Il Titolare del trattamento è la Abdessalem Sarah (P.I 04457370163)
          con sede legale in 20063, Cernusco Sul Naviglio, Via Andrea Fermini n.
          1 Si informa che i Dati forniti potranno essere trattati da altri
          soggetti coinvolti nell’organizzazione del Titolare, tutti in qualità
          di incaricati al trattamento, ovvero soggetti esterni (come fornitori
          di servizi tecnici terzi, hosting provider, fornitori di piattaforme
          per pagamenti online, piattaforme per l’erogazione di corsi di
          formazione), nominati incaricati o, se necessario, Responsabili
          Esterni del Trattamento da parte del Titolare.
          <h5 class="text-theme-dark">D. MODALITÀ DI TRATTAMENTO</h5>
          I dati personali forniti verranno trattati presso la sede del Titolare
          o da Responsabili Esterni del Trattamento nominati dal Titolare stesso
          (fornitori di servizi informatici e logistici; fornitori di servizi in
          outsourcing e cloud computing e di servizi gestionali; professionisti
          esterni e consulenti; società incaricate di effettuare le attività di
          marketing e/o di spedizione). Il trattamento avverrà tramite procedure
          informatiche e/o telematiche nei modi e nei limiti necessari per
          perseguire le predette finalità e verranno conservati presso la
          medesima sede. Il Titolare si avvale di servizi resi da primarie
          società del settore incaricate di svolgere attività di sviluppo e
          manutenzione dei software gestionali e della manutenzione tecnica del
          sito.
          <h5 class="text-theme-dark">
            E. TRASFERIMENTO DEI DATI IN PAESI TERZI
          </h5>
          Il Titolare dichiara che i dati trattati non vengono trasferiti presso
          terzi.

          <h5 class="text-theme-dark">F. PERIODO DI CONSERVAZIONE</h5>
          Si informa che i Dati forniti verranno trattati e conservati dal
          Titolare per le finalità sopra indicate e conservati presso il
          Titolare con le tempistiche sotto riportate. In caso di fatturazione,
          i dati relativi agli acquisti effettuati saranno conservati per 10
          anni dalla data di fatturazione, come previsto dalla legge applicabile
          in materia fiscale. Nel caso in cui Lei abbia acconsentito al
          trattamento dei Suoi dati personali per finalità di marketing, i Suoi
          dati personali saranno trattati fino a quando Lei non avrà revocato il
          consenso al trattamento dei Suoi dati per finalità di marketing per
          tutte o alcune le modalità di contatto, salvo che la conservazione dei
          Suoi dati sia ancora necessaria per altre finalità contemplate dalla
          presente informativa. Una volta conferito il consenso per finalità di
          Marketing e/o profilazione i suoi dati verrano trattati sino a che non
          verrà revocato il consenso prestato. Le sarà possibile revocare il
          consenso tramite link che sarà allegato ad ogni comunicazione
          commerciale che Le verrà inviata. Una volta esercitato il Suo diritto
          di revoca, il Titolare del Trattamento non Le invierà più alcun tipo
          di comunicazione di tipo commerciale. I Dati personali raccolti per
          finalità riconducibili all’interesse legittimo del Titolare saranno
          trattenuti sino al soddisfacimento di tale interesse.

          <h5 class="text-theme-dark">G. DIRITTI DELL’INTERESSATO</h5>
          L’interessato può in ogni momento esercitare i Suoi diritti nei
          confronti del Titolare del trattamento ai sensi del D. Lgs. 193/2006 e
          del Regolamento (UE) 2016/679 come richiamati dai seguenti articoli:

          <ul>
            <li>
              <b>DIRITTO DI ACCESSO ALL’INTERESSATO</b> - Art. 15 Reg. (UE)
              2016/679
            </li>
            <li><b>DIRITTO DI RETTIFICA</b> - Art. 15 Reg. (UE) 2016/679</li>
            <li>
              <b>DIRITTO ALLA CANCELLAZIONE (“DIRITTO ALL’OBLIO”)</b> - Art. 17
              Reg. (UE) 2016/679
            </li>
            <li>
              <b>DIRITTO ALLA LIMITAZIONE DI TRATTAMENTO</b> - Art. 18 Reg. (UE)
              2016/679
            </li>
            <li>
              <b>DIRITTO ALLA PORTABILITA’ DEI DATI</b> - Art. 20 Reg. (UE)
              2016/679
            </li>
            <li><b>DIRITTO DI OPPOSIZIONE</b> - Art. 21Reg. (UE) 2016/679</li>
          </ul>

          <h5 class="text-theme-dark">
            REGOLE GENERALI DI ESERCIZIO DEI DIRITTI
          </h5>
          La informiamo che i diritti di cui ai paragrafi che precedono potranno
          essere esercitati in qualunque momento inviando una mail al seguente
          indirizzo: sarah.abdessalem@pec.it unitamente ad una copia digitale
          del suo documento di identità in corso di validità. Le ricordiamo che
          qualora ci chieda di interrompere tutti i trattamenti dei suoi dati
          personali e non solo quelli per finalità promozionali, non saremo in
          grado di continuare a fornirle i servizi che ci ha richiesto e che,
          salvo che richieda di interrompere il solo invio di comunicazioni
          promozionali attraverso sistemi automatizzati, in caso di sua
          richiesta generica interromperemo ogni trattamento dei suoi dati
          personali anche attraverso strumenti tradizionali. In ogni caso, la
          nostra società potrà conservare taluni suoi dati personali qualora
          potessero risultarle necessari per difendere o far valere un proprio
          diritto. Ove lo desideri, l’elenco aggiornato recante i nominativi dei
          Responsabili dei trattamenti dei suoi dati è a sua disposizione presso
          la sede del Titolare del trattamento, al quale potrà chiederlo anche
          via e-mail scrivendo a sarah.abdessalem@pec.it)

          <h5 class="text-theme-dark">DEFINIZIONI</h5>
          <br /><b>ART. 5 GDPR</b>
          Ai fini del presente regolamento s’intende per:
          <br /><b>Dato personale:</b> qualsiasi informazione riguardante una
          persona fisica identificata o identificabile, detta anche
          “interessato”; si considera identificabile la persona fisica che può
          essere identificata, direttamente o indirettamente, con particolare
          riferimento a un identificativo come il nome, un numero di
          identificazione, dati relativi all’ubicazione, un identificativo
          online o a uno o più elementi caratteristici della sua identità
          fisica, fisiologica, genetica, psichica, economica, culturale o
          sociale; <br /><b>Trattamento:</b> qualsiasi operazione o insieme di
          operazioni, compiute con o senza l’ausilio di processi automatizzati e
          applicate a dati personali o insiemi di dati personali, come la
          raccolta, la registrazione, l’organizzazione, la strutturazione, la
          conservazione, l’adattamento o la modifica, l’estrazione, la
          consultazione, l’uso, la comunicazione mediante trasmissione,
          diffusione o qualsiasi altra forma di messa a disposizione, il
          raffronto o l’interconnessione, la limitazione, la cancellazione o la
          distruzione; <br /><b>Limitazione del trattamento:</b> il contrassegno
          dei dati personali conservati con l’obiettivo di limitarne il
          trattamento in futuro; <br /><b>Profilazione:</b> qualsiasi forma di
          trattamento automatizzato di dati personali consistente nell’utilizzo
          di tali dati personali per valutare determinati aspetti personali
          relativi a una persona fisica, in particolare per analizzare o
          prevedere aspetti riguardanti il rendimento professionale, la
          situazione economica, la salute, le preferenze personali, gli
          interessi, l’affidabilità, il comportamento, l’ubicazione o gli
          spostamenti di detta persona fisica; <br /><b>Pseudonimizzazione:</b>
          il trattamento dei dati personali in modo tale che i dati personali
          non possano più essere attribuiti a un interessato specifico senza
          l’utilizzo di informazioni aggiuntive, a condizione che tali
          informazioni aggiuntive siano conservate separatamente e soggette a
          misure tecniche e organizzative intese a garantire che tali dati
          personali non siano attribuiti a una persona fisica identificata o
          identificabile;

          <br /><b>Archivio:</b> qualsiasi insieme strutturato di dati personali
          accessibili secondo criteri determinati, indipendentemente dal fatto
          che tale insieme sia centralizzato, decentralizzato o ripartito in
          modo funzionale o geografico; <br /><b>Titolare del trattamento:</b>
          la persona fisica o giuridica, l’autorità pubblica, il servizio o
          altro organismo che, singolarmente o insieme ad altri, determina le
          finalità e i mezzi del trattamento di dati personali; quando le
          finalità e i mezzi di tale trattamento sono determinati dal diritto
          dell’Unione o degli Stati membri, il titolare del trattamento o i
          criteri specifici applicabili alla sua designazione possono essere
          stabiliti dal diritto dell’Unione o degli Stati membri; <br /><b
            >Responsabile del trattamento:</b
          >
          la persona fisica o giuridica, l’autorità pubblica, il servizio o
          altro organismo che tratta dati personali per conto del titolare del
          trattamento; Destinatario: la persona fisica o giuridica, l’autorità
          pubblica, il servizio o un altro organismo che riceve comunicazione di
          dati personali, che si tratti o meno di terzi. Tuttavia, le autorità
          pubbliche che possono ricevere comunicazione di dati personali
          nell’ambito di una specifica indagine conformemente al diritto
          dell’Unione o degli Stati membri non sono considerate destinatari; il
          trattamento di tali dati da parte di dette autorità pubbliche è
          conforme alle norme applicabili in materia di protezione dei dati
          secondo le finalità del trattamento; <br /><b>Terzo:</b> la persona
          fisica o giuridica, l’autorità pubblica, il servizio o altro organismo
          che non sia l’interessato, il titolare del trattamento, il
          responsabile del trattamento e le persone autorizzate al trattamento
          dei dati personali sotto l’autorità diretta del titolare o del
          responsabile; <br /><b>Consenso dell’interessato:</b> qualsiasi
          manifestazione di volontà libera, specifica, informata e
          inequivocabile dell’interessato, con la quale lo stesso manifesta il
          proprio assenso, mediante dichiarazione o azione positiva
          inequivocabile, che i dati personali che lo riguardano siano oggetto
          di trattamento; <br /><b>Violazione dei dati personali:</b> la
          violazione di sicurezza che comporta accidentalmente o in modo
          illecito la distruzione, la perdita, la modifica, la divulgazione non
          autorizzata o l’accesso ai dati personali trasmessi, conservati o
          comunque trattati; <br /><b>Dati genetici:</b> i dati personali
          relativi alle caratteristiche genetiche ereditarie o acquisite di una
          persona fisica che forniscono informazioni univoche sulla fisiologia o
          sulla salute di detta persona fisica, e che risultano in particolare
          dall’analisi di un campione biologico della persona fisica in
          questione; <br /><b>Dati biometrici:</b> i dati personali ottenuti da
          un trattamento tecnico specifico relativi alle caratteristiche
          fisiche, fisiologiche o comportamentali di una persona fisica che ne
          consentono o confermano l’identificazione univoca, quali l’immagine
          facciale o i dati dattiloscopici; Dati relativi alla salute: i dati
          personali attinenti alla salute fisica o mentale di una persona
          fisica, compresa la prestazione di servizi di assistenza sanitaria,
          che rivelano informazioni relative al suo stato di salute; <br /><b
            >Stabilimento principale:</b
          >
          a) per quanto riguarda un titolare del trattamento con stabilimenti in
          più di uno Stato membro, il luogo della sua amministrazione centrale
          nell’Unione, salvo che le decisioni sulle finalità e i mezzi del
          trattamento di dati personali siano adottate in un altro stabilimento
          del titolare del trattamento nell’Unione e che quest’ultimo
          stabilimento abbia facoltà di ordinare l’esecuzione di tali decisioni,
          nel qual caso lo stabilimento che ha adottato siffatte decisioni è
          considerato essere lo stabilimento principale; b) con riferimento a un
          responsabile del trattamento con stabilimenti in più di uno Stato
          membro, il luogo in cui ha sede la sua amministrazione centrale
          nell’Unione o, se il responsabile del trattamento non ha
          un’amministrazione centrale nell’Unione, lo stabilimento del
          responsabile del trattamento nell’Unione in cui sono condotte le
          principali attività di trattamento nel contesto delle attività di uno
          stabilimento del responsabile del trattamento nella misura in cui tale
          responsabile è soggetto a obblighi specifici ai sensi del presente
          regolamento;
          <br /><b>Rappresentante:</b> la persona fisica o giuridica stabilita
          nell’Unione che, designata dal titolare del trattamento o dal
          responsabile del trattamento per iscritto ai sensi dell’articolo 27,
          li rappresenta per quanto riguarda gli obblighi rispettivi a norma del
          presente regolamento; <br /><b>Impresa:</b> la persona fisica o
          giuridica, indipendentemente dalla forma giuridica rivestita, che
          eserciti un’attività economica, comprendente le società di persone o
          le associazioni che esercitano regolarmente un’attività economica;
          <br /><b>Gruppo imprenditoriale:</b> un gruppo costituito da
          un’impresa controllante e dalle imprese da questa controllate;
          <br /><b>Norme vincolanti d’impresa:</b> le politiche in materia di
          protezione dei dati personali applicate da un titolare del trattamento
          o responsabile del trattamento stabilito nel territorio di uno Stato
          membro al trasferimento o al complesso di trasferimenti di dati
          personali a un titolare del trattamento o responsabile del trattamento
          in uno o più paesi terzi, nell’ambito di un gruppo imprenditoriale o
          di un gruppo di imprese che svolge un’attività economica comune;
          <br /><b>Autorità di controllo:</b> l’autorità pubblica indipendente
          istituita da uno Stato membro ai sensi dell’articolo 51; <br /><b
            >Autorità di controllo interessata:</b
          >
          un’autorità di controllo interessata dal trattamento di dati personali
          in quanto: a) il titolare del trattamento o il responsabile del
          trattamento è stabilito sul territorio dello Stato membro di tale
          autorità di controllo; b) gli interessati che risiedono nello Stato
          membro dell’autorità di controllo sono o sono probabilmente
          influenzati in modo sostanziale dal trattamento; oppure c) un reclamo
          è stato proposto a tale autorità di controllo; <br /><b
            >Trattamento transfrontaliero:</b
          >
          a) trattamento di dati personali che ha luogo nell’ambito delle
          attività di stabilimenti in più di uno Stato membro di un titolare del
          trattamento o responsabile del trattamento nell’Unione ove il titolare
          del trattamento o il responsabile del trattamento siano stabiliti in
          più di uno Stato membro; oppure b) trattamento di dati personali che
          ha luogo nell’ambito delle attività di un unico stabilimento di un
          titolare del trattamento o responsabile del trattamento nell’Unione,
          ma che incide o probabilmente incide in modo sostanziale su
          interessati in più di uno Stato membro;
          <br /><b>Obiezione pertinente e motivata:</b> un’obiezione al progetto
          di decisione sul fatto che vi sia o meno una violazione del presente
          regolamento, oppure che l’azione prevista in relazione al titolare del
          trattamento o responsabile del trattamento sia conforme al presente
          regolamento, la quale obiezione dimostra chiaramente la rilevanza dei
          rischi posti dal progetto di decisione riguardo ai diritti e alle
          libertà fondamentali degli interessati e, ove applicabile, alla libera
          circolazione dei dati personali all’interno dell’Unione; <br /><b
            >Servizio della società dell’informazione:</b
          >
          il servizio definito all’articolo 1, paragrafo 1, lettera b), della
          direttiva (UE) 2015/1535 del Parlamento europeo e del Consiglio (19);
          <br /><b>Organizzazione internazionale:</b> un’organizzazione e gli
          organismi di diritto internazionale pubblico a essa subordinati o
          qualsiasi altro organismo istituito da o sulla base di un accordo tra
          due o più Stati.
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Privacy",
};
</script>